import { createElement, useState } from 'react';
import { Form, ResponsiveGrid, Input, NumberPicker, CascaderSelect, DatePicker2, } from '@alifd/next';
import { DictSelectRef as DictSelect } from '@/components/form/form/components/form-dict-select';
import SearchTable from '@/components/form/form/components/form-search-table/serach-table';
import ApiSelect from '@/components/form/form/components/form-api-select';
import UniqueCodeSelect from '@/components/form/form/components/form-unique-code-select';
import ProCard from '@/components/layout/pro-card';
import EditTable from './edit-table';
import { AccountingEventServiceCall, AccountingEventEntityMapping } from '@/components/business';
import { isEmpty } from 'lodash-es';
import { useDeepCompareEffect } from 'ahooks';
export const customBusinessComponent = [
    {
        title: '会计事件服务调用',
        value: 'AccountingEventServiceCall',
        Component: AccountingEventServiceCall,
    },
    {
        title: '实体映射',
        value: 'AccountingEventEntityMapping',
        Component: AccountingEventEntityMapping,
    },
];
const Component = (props) => {
    const { formBlocks = [], field, __designMode, changingField, editTableRef, editType } = props;
    const [renderData, setRenderData] = useState([]);
    const { values } = field;
    const getRenderData = (formBlocks) => {
        return formBlocks.map((item) => {
            const { componentName, isCollapse, isShowHeader, operations, title, formItems = [], listName, primaryKey, status, columns, labelAlign, labelCol, wrapperCol, labelTextAlign, emptyContent, mapName, serviceCall, targetAndSourceCfgList = [], mapListName } = item;
            const blockProps = {
                title,
                isCollapse,
                key: primaryKey,
                listName,
                isShowHeader,
                operations,
                field,
            };
            const formProps = {
                primaryKey,
                status,
                labelAlign,
                labelCol,
                wrapperCol,
                labelTextAlign,
                spacing: [0, 16, 16, 0],
                emptyContent,
                columns,
            };
            const foundComponent = customBusinessComponent.find((item) => item.value === componentName);
            if (foundComponent) {
                const Components = foundComponent?.Component;
                const fundProps = {
                    blockProps,
                    field,
                    listName,
                    __designMode,
                    formProps,
                    editTableRef,
                    changingField,
                    formItems,
                    serviceCall,
                    mapName,
                    title,
                    targetAndSourceCfgList,
                    mapListName,
                    editType
                };
                return createElement(Components, { ...fundProps });
            }
            if (componentName === 'Table') {
                return (createElement(ProCard, { ...blockProps },
                    createElement(EditTable, { field: field, listName: listName, __designMode: __designMode, formProps: formProps, getHandler: (handler) => {
                            editTableRef.current = handler;
                        }, changingField: changingField, getSelectRow: (val) => { }, editType: editType }, formItems)));
            }
            return (createElement(ProCard, { ...blockProps },
                createElement(Form, { ...formProps, useLabelForErrorMessage: true, field: field },
                    createElement(ResponsiveGrid, { gap: [0, 16, 16, 0], columns: columns }, formItems.map((item) => {
                        const { hidden = [] } = item;
                        const flag = hidden.every(d => {
                            const { name, operationRelation, referenceValue } = d || {};
                            const compareValue = field.getValue(name);
                            const isTrue = compareData(compareValue, operationRelation, referenceValue);
                            return isTrue;
                        });
                        if (!flag) {
                            return null;
                        }
                        return (createElement(ResponsiveGrid.Cell, { colSpan: item.columnSpan }, renderFormItem({ ...item, isPreview: editType === 'view' ? true : item?.isPreview }, {
                            labelAlign,
                            labelCol,
                            wrapperCol,
                            labelTextAlign,
                            changingField,
                            field,
                        })));
                    })))));
        });
    };
    useDeepCompareEffect(() => {
        if (!isEmpty(formBlocks)) {
            const renderBlock = getRenderData(formBlocks);
            setRenderData(renderBlock);
        }
    }, [formBlocks, values, editType, __designMode, changingField]);
    return renderData;
};
export default Component;
export const renderFormItem = ({ componentName, componentProps, ...rest }, globalFormProps) => {
    const { changingField, field, ...restGlobalProps } = globalFormProps;
    switch (componentName) {
        case 'CbayelFormInput':
            return (createElement(Form.Item, { ...restGlobalProps, ...rest },
                createElement(Input, { ...componentProps })));
        case 'CbayelFormNumberInput':
            return (createElement(Form.Item, { ...restGlobalProps, ...rest },
                createElement(NumberPicker, { ...componentProps })));
        case 'CbayelFormCascaderSelect':
            return (createElement(Form.Item, { ...restGlobalProps, ...rest },
                createElement(CascaderSelect, { ...componentProps })));
        case 'CbayelFormDatePicker':
            return (createElement(Form.Item, { ...restGlobalProps, ...rest },
                createElement(DatePicker2, { ...componentProps })));
        case 'CbayelFormDateRangePicker':
            return (createElement(Form.Item, { ...restGlobalProps, ...rest },
                createElement(DatePicker2.RangePicker, { ...componentProps })));
        case 'CbayelFormDictSelect':
            return (createElement(Form.Item, { ...restGlobalProps, ...rest },
                createElement(DictSelect, { ...componentProps })));
        case 'CbayelFormPassword':
            return (createElement(Form.Item, { ...restGlobalProps, ...rest },
                createElement(Input.Password, { ...componentProps })));
        case 'CbayelFormSearchTable':
            return (createElement(Form.Item, { ...restGlobalProps, ...rest },
                createElement(SearchTable, { ...componentProps })));
        case 'CbayelFormTextArea':
            return (createElement(Form.Item, { ...restGlobalProps, ...rest },
                createElement(Input.TextArea, { ...componentProps })));
        case 'CbayelFormApiSelect':
            return (createElement(Form.Item, { ...restGlobalProps, ...rest },
                createElement(ApiSelect, { ...componentProps, changingField: changingField, field: field })));
        case 'CbayelFormUniqueCodeSelect':
            return (createElement(Form.Item, { ...restGlobalProps, ...rest },
                createElement(UniqueCodeSelect, { ...componentProps })));
        default:
            return (createElement(Form.Item, { ...restGlobalProps, ...rest },
                createElement(Input, { ...componentProps })));
    }
};
export const compareData = (param, operation, value) => {
    switch (operation) {
        case '===':
            return param === value;
        case '>':
            return param > value;
        case '<':
            return param < value;
        case '>=':
            return param >= value;
        case '<=':
            return param <= value;
        default:
            return false;
    }
};
